import { Theme } from '@mui/material'

import { scrollbarStyleDefaultHidden } from './scrollbarStyle'
import { pxToRem } from './themes'

export const getComponentOverrides = (theme: Theme) => ({
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: pxToRem(12),
        // Ensure dialog starts from below and animates up
        transform: 'translateY(0)',
        
        [theme.breakpoints.up('sm')]: {
          width: '100%',
        },
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        fontFamily: theme.typography.fontFamily,
        fontSize: pxToRem(14),
        color: theme.palette.text.secondary,
        fontWeight: 400,
        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  MuiContainer: {
    styleOverrides: {
      root: {
        paddingLeft: `${pxToRem(16)} !important`,
        paddingRight: `${pxToRem(16)} !important`,

        [theme.breakpoints.up('sm')]: {
          paddingLeft: `${pxToRem(24)} !important`,
          paddingRight: `${pxToRem(24)} !important`,
        },
      },
      maxWidthXs: {
        [theme.breakpoints.up('xs')]: {
          maxWidth: pxToRem(444 + (20 * 2)),
        },
      },
      maxWidthSm: {
        [theme.breakpoints.up('sm')]: { // >=600px & <900px Before 900, change all menus into hamburger and re-order the items
          maxWidth: pxToRem(600 + (20 * 2)),
        },
      },
      maxWidthMd: {
        [theme.breakpoints.up('md')]: { // >=900px & <1200px => 
          maxWidth: pxToRem(1000 + (20 * 2)),
        },
      },
      maxWidthLg: {
        [theme.breakpoints.up('lg')]: { // >1200px
          maxWidth: pxToRem(1360 + (20 * 2)),
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: pxToRem(8),
        boxShadow: '0 5px 30px rgba(0, 0, 0, 0.15)',
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        position: 'relative',

        '& .MuiTabs-scroller': {
          overflowX: 'auto !important',
          ...scrollbarStyleDefaultHidden,
        },

        '.MuiTabs-indicator': {
          height: '3px',
          borderRadius: pxToRem(3),
        },
      },
      scroller: {
        overflowX: 'auto !important',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          backgroundColor: theme.palette.divider,
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        color: theme.palette.text.disabled,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 500,
        textTransform: 'none',
        '&.Mui-selected': {
          fontWeight: 500,
          color: theme.palette.text.primary,

          '&:before': {
            opacity: 1,
          },
        },

      },
    },
  },
})
